export default class Slider {
  constructor(options, callback) {
    if (options?.el) {
      this.init(options, callback)
    }
  }

  init(options, callback) {
    this.slider = typeof options.el === 'string' ? document.querySelector(options.el) : options.el
    this.slides = this.slider?.children
    this.activeSlides = []
    this.setActiveSlides()
    this.filtering = false
    this.totalSlides = this?.slides?.length
    this.slideWidth = this?.slides[0].clientWidth
    this.position = this?.slider.scrollLeft
    this.callback = callback
    this.isMin = this.position === 0 || this.slideIndex === 0 ? true : false
    this.isMax = this.slideIndex === this.slides.length - 1 ? true : false
    this.slideIndex = 0
    this.threshold = options.threshold ?? 0.75
    this.rootMargin = options.rootMargin ?? '0px'

    if (this.slider.childElementCount > 1) {
      const observer = new IntersectionObserver(this.intersectionCallback, {
        root: this.slider,
        rootMargin: this.rootMargin,
        threshold: this.threshold,
      })

      for (var i = 0; i < this.slider.childElementCount; i++) {
        if (this.slider.children[i].hasAttribute('data-index') === false) {
          this.slider.children[i].setAttribute('data-index', i)
        }
        observer.observe(this.slider.children[i])
      }
    }
  }

  slideLeft(behavior = 'smooth') {
    this.slideWidth = this.activeSlides[0].clientWidth
    this.position = this.slider.scrollLeft - this.slideWidth
    this.slider.scrollTo({
      left: this.position,
      top: 0,
      behavior,
    })
  }

  slideRight(behavior = 'smooth') {
    this.slideWidth = this.activeSlides[0].clientWidth
    this.position = this.slider.scrollLeft + this.slideWidth
    this.slider.scrollTo({
      left: this.position,
      top: 0,
      behavior,
    })
  }

  slideTo(index, behavior = 'smooth') {
    index = typeof parseInt(index) === 'number' && !isNaN(index) ? parseInt(index) : index.getAttribute('data-index')
    this.slideWidth = this.activeSlides[0].clientWidth
    this.position = this.slideWidth * index
    this.slider.scrollTo({
      left: this.position,
      top: 0,
      behavior,
    })
  }

  slideToElement(el, behavior = 'smooth') {
    if (typeof el === 'string' || el instanceof String) {
      el = document.querySelector(el)
    }
    this.position = el.offsetLeft
    this.slider.scrollTo({
      left: this.position,
      top: 0,
      behavior,
    })
  }

  filter(callback) {
    this.filtering = true
    if (callback)
      callback().then(() => {
        this.setActiveSlides()
        this.filtering = false
      })
  }

  setFilterState(value) {
    this.filtering = value
  }

  setActiveSlides() {
    this.activeSlides = []
    if (this.slides) {
      for (let i = 0; i < this.slides.length; i++) {
        if (this.slides[i].getAttribute('data-active') === 'true') {
          this.activeSlides.push(this.slides[i])
        }
      }
      if (this.activeSlides.length === 0) {
        this.activeSlides = this.slides
      }
    }
  }

  setMinMax(e) {
    this.slideIndex = parseInt(e.target.getAttribute('data-index'))
    this.position = this.slider.scrollLeft
    this.isMin = this.position === 0 || this.slideIndex === 0 ? true : false
    this.isMax = this.slideIndex === this.activeSlides.length - 1 ? true : false
  }

  intersectionCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry && entry.isIntersecting && this.filtering === false) {
        this.setMinMax(entry)
        this.callback &&
          this.callback({
            slides: this.activeSlides,
            el: entry.target,
            index: this.slideIndex,
            isMin: this.isMin,
            isMax: this.isMax,
            filtering: this.filtering,
          })
      }
    })
  }
}
